import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'

const Sport8RefundAuditsContainer = () => {
  const getNavBarTitle = () => {
    const pathName = location.pathname

    if (pathName.match(/^\/sport8-refund-audits\/[0-9]+$/)) {
      return translate('navBar.viewSport8RefundAuditTitle')
    }

    if (pathName.match(/^\/sport8-refund-audits\/new/)) {
      return translate('navBar.newSport8RefundAuditTitle')
    }

    return translate('navBar.sport8RefundAuditsTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()} />
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default Sport8RefundAuditsContainer
